import {
	OrderGridTable,
	OrderNotesMarker,
	OrderParticipants,
	OrderPerson,
	OrderStatus,
	OrderTime,
	OrderVisitDate,
	selectWaitingOrders,
	useOrderInfo,
} from 'entities/orders';
import { Tags } from 'entities/tags';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'shared/lib/store';
import { Flex } from 'shared/ui/flex';
import { GridRows } from 'shared/ui/gridTable';

export const OrderWaitingList = () => {
	const [rows, setRows] = useState<GridRows[]>([]);
	const orders = useAppSelector(selectWaitingOrders);

	const { open, setSelectedId, isOpen } = useOrderInfo();

	const [currentRowId, setCurrentRowId] = useState<number | undefined>(
		undefined,
	);

	const selectOrder = (id: number) => {
		open();
		setCurrentRowId(id);
		setSelectedId(id);
	};

	useEffect(() => {
		if (!isOpen) {
			setCurrentRowId(undefined);
		}

	}, [isOpen])

	useEffect(() => {
		if (orders.length) {
			const ordersMap = orders.map(order => {
				return {
					id: order.id,
					fields: [
						<OrderPerson person={order.person} width="18vw" />,
						<OrderTime order={order} />,
						<OrderParticipants order={order} />,
						<OrderVisitDate
							order={order}
							includeCalendarIcon={true}
						/>,
						<Tags
							tags={order.tags}
							tagsFor={'order'}
							currentEntityId={order.id}
						/>,
						<Flex $direction="column">
							<OrderNotesMarker order={order} />
							<OrderStatus
								order={order}
								enabledStatuses={['visit_missed', 'cancelled']}
							/>
						</Flex>,
					],
				};
			});

			setRows([{ rows: [{ cells: ordersMap }] }]);
		} else {
			setRows([]);
		}
	}, [orders]);

	return (
		<OrderGridTable
			tableRows={rows}
			columnCount={6}
			selectOrder={selectOrder}
			currentRowId={currentRowId}
			gridSettings={{
				moreSpaceForLastColumn: false,
				columnSize: 8,
			}}
			specificColumnSizes={[
				{ index: 1, size: 4 },
				{ index: 2, size: 2 },
				{ index: 3, size: 1 },
				{ index: 4, size: 3 },
				{ index: 5, size: 12 },
				{ index: 6, size: 1 },
			]}
			gridStyles={{
				rowPadding: '8px 10px',
				rowHeight: '64px',
				rowMargin: '0px',
				rowCorners: '0px',
			}}
			error={null}
		/>
	);
};
